import React from 'react'

const ChevronLeft = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      transform="translate(0 0.621582)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7891 4.80189C12.0577 5.05372 12.0713 5.4756 11.8195 5.74421L7.24699 10.6216L11.8195 15.4989C12.0713 15.7676 12.0577 16.1894 11.7891 16.4413C11.5205 16.693 11.0986 16.6794 10.8468 16.4109L5.84681 11.0775C5.6064 10.8211 5.6064 10.4221 5.84681 10.1656L10.8468 4.83229C11.0986 4.56368 11.5205 4.55008 11.7891 4.80189Z"
      fill="#3E3E47"
    />
  </svg>
)

export default ChevronLeft
